import React from 'react';
import { Avatar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';

const style = {
  width: 64,
  height: 64,
  emptyStateIcon: {
    borderRadius: '50%',
    sx: {
      bgColor: 'primary.main',
    },
  },
  fontSize: 25,
} as const;

export const EmptyAvatar = ():JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Avatar
      alt={ translate(STRING_KEYS.EMPTY_AVATAR) }
      src=""
      sx={ { width: style.width, height: style.height } }
    />
  );
};
